<template>
  <div class="card h-100">
    <div class="d-flex flex-column h-100">
      <div>
        <a :href="`/posts/${post.id}`">
          <RatioImage
            ratio="2:1"
            :src="imgProxy(post.thumbnail, rs='fill:400:200:1')"
            :tip="post.title"
            class="card-img-top"
          />
          <div class="mt-1 text-muted text-right mr-2 font-size-xs">
            {{ dateFormat(post.published_at, format) }}
          </div>
    
          <div class="card-body p-2 d-flex flex-column" style="height: 110px;">
            <h6 class="card-title text-truncate-3">{{ post.title }}</h6>
            <div class="text-truncate font-size-sm mt-auto">
              {{ post.summary }}
            </div>
          </div>
        </a>
      </div>
      <div class="px-2 pt-0 mb-2 mt-auto">
        <a :href="`/posts/${post.id}`" class="btn btn-outline-primary btn-block">
          {{ post?.extra_context?.feed_settings?.cta || '點我看更多' }}
        </a>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { dateFormat, imgProxy } from "../../utils"
import RatioImage from '../RatioImage.vue'

const props = defineProps({
  post: Object,
})

const format = "YYYY/MM/DD"

</script>